class ObjectMethods {
  static clone(data: any): any {
    return JSON.parse(JSON.stringify(data));
  }
  static compare(o1: any, o2: any): boolean {
    return JSON.stringify(o1) === JSON.stringify(o2);
  }
}

export default ObjectMethods;